import { Routes, Route, BrowserRouter } from "react-router-dom";
import AuthProvider from './components/auth/auth-context';

//Public pages
import NotFoundPage from "./pages/public/NotFoundPage";
import LoginPage from "./pages/public/LoginPage";
import InvitationsPage from "./pages/public/InvitationsPage";
import ProfilesReviewPage from "./pages/public/ProfilesReviewPage";
import ProfilesReviewIframePage from "./pages/public/ProfilesReviewIframePage";
import VendorsReviewCodePage from "./pages/public/VendorsReviewCodePage";
import VendorsReviewInvoicePage from "./pages/public/VendorsReviewInvoicePage";
import UnsubscribePage from "./pages/public/UnsubscribePage";
import PasswordResetPage from "./pages/public/PasswordResetPage";
import VendorsReviewGroup from "./pages/public/VendorsReviewGroup";


//Private pages
import DashboardPage from "./pages/DashboardPage";
import PrizeGames from "./pages/PrizeGames";
import Invitations from "./pages/Invitations";
import WidgetOverview from "./pages/WidgetOverview";
import Groups from "./pages/Groups";
import Settings from "./pages/Settings";
import ReviewsPage from "./pages/ReviewsPage";
import CertificatePage from "./pages/CertificatePage";
import ReportPage from "./pages/ReportPage";
import TranslationTable from "./pages/TranslationTable";

// Layouts
import PublicLayout from './layouts/PublicLayout';
import PrivateLayout from './layouts/PrivateLayout';
import HybridLayout from './layouts/HybridLayout';

// Routes
const publicRoutes = [
  { path: "/invitations/:invitationId", component: InvitationsPage, layout: PublicLayout },
  { path: "/profiles/:profileId/review", component: ProfilesReviewPage, layout: PublicLayout },
  { path: "/profiles/:profileId/review-iframe", component: ProfilesReviewIframePage, layout: PublicLayout },
  { path: "/vendors/:vendorId/review-from-code", component: VendorsReviewCodePage, layout: PublicLayout },
  { path: "/vendors/:vendorId/invoice-code-input", component: VendorsReviewInvoicePage, layout: PublicLayout },
  { path: "/vendors/:vendorId/review-group/:groupID", component: VendorsReviewGroup, layout: PublicLayout },
  { path: "/unsubscribe/:invitationId", component: UnsubscribePage, layout: PublicLayout },
  { path: "/users/password/:resetToken", component: PasswordResetPage, layout: PublicLayout },
  { path: "/vendors/:vendorId/certificate", component: CertificatePage, layout: HybridLayout },
  { path: "/v/:vSlug/", component: VendorsReviewCodePage, layout: PublicLayout },
  { path: "/v/:vSlug/:element", component: VendorsReviewCodePage, layout: PublicLayout },

  { path: "/artur-demo/", component: VendorsReviewInvoicePage, layout: PublicLayout },
];

const publicRoutesAdmin = [
  { path: "/login/", component: LoginPage, layout: PublicLayout },
  { path: "/login/:userId", component: LoginPage, layout: PublicLayout }
];

const privateRoutesAdmin = [
  { path: "/", component: DashboardPage, layout: PrivateLayout },
  { path: "/vendors/:vendorId/dashboard", component: DashboardPage, layout: PrivateLayout },
  { path: "/vendors/:vendorId/prize-games", component: PrizeGames, layout: PrivateLayout },
  { path: "/vendors/:vendorId/invitations", component: Invitations, layout: PrivateLayout },
  { path: "/vendors/:vendorId/link", component: Invitations, layout: PrivateLayout },
  { path: "/vendors/:vendorId/email", component: Invitations, layout: PrivateLayout },
  { path: "/vendors/:vendorId/viberSms", component: Invitations, layout: PrivateLayout },
  { path: "/vendors/:vendorId/qr", component: Invitations, layout: PrivateLayout },
  { path: "/vendors/:vendorId/batch", component: Invitations, layout: PrivateLayout },
  { path: "/vendors/:vendorId/list", component: Invitations, layout: PrivateLayout },
  { path: "/vendors/:vendorId/widget-overview", component: WidgetOverview, layout: PrivateLayout },
  { path: "/vendors/:vendorId/groups", component: Groups, layout: PrivateLayout },
  { path: "/vendors/:vendorId/settings", component: Settings, layout: PrivateLayout },
  { path: "/vendors/:vendorId/reviews", component: ReviewsPage, layout: PrivateLayout },
  { path: "/vendors/:vendorId/certificate", component: CertificatePage, layout: PrivateLayout },
  { path: "/vendors/:vendorId/report", component: ReportPage, layout: PrivateLayout },
  { path: "/translation", component: TranslationTable, layout: PrivateLayout },
];


const AdminRoutes = () => (
  <Routes>
    {privateRoutesAdmin.map(({ path, component: Component, layout: Layout }) => (
      <Route index  key={path} path={path} element={<Layout><Component /></Layout>} />
    ))}
    {publicRoutesAdmin.map(({ path, component: Component, layout: Layout }) => (
      <Route index  key={path} path={path} element={<Layout><Component /></Layout>} />
    ))}
     <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

function App() {
  return (
<div className="App">
  <BrowserRouter>
    <AuthProvider>
      <Routes>
        <Route index path="/admin/*" element={<AdminRoutes />}/>
        {publicRoutes.map(({ path, component: Component, layout: Layout }) => (
          <Route key={path} path={path} element={<Layout><Component /></Layout>} />
        ))}
         {/* Catch-all route for 404 */}
         <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
  </BrowserRouter>
</div>
  );
}

export default App;